//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: [
        'src',
        'srcSmall',
        'contain'
    ],
    data () {
        return {
            smallLoaded: false,
            largeLoaded: false
        }
    },
    mounted() {
        var that = this
        // 1: load small image and show it
        var img = new Image()
        img.src = this.srcSmall
        img.onload = function () {
            that.smallLoaded = true
        };
        // 2: load large image
        var imgLarge = new Image();
        imgLarge.src = this.src;
        imgLarge.onload = function () {
            setTimeout(function() {
                that.smallLoaded = false
                that.largeLoaded = true
            }, 300)
        };
    }
}



// WEBPACK FOOTER //
// ./scripts/vue/lazy-image.vue